'use strict';

const Qubit = require('./qubit');

/**
 * A dynamically growing pool of used qubits which can
 * be freed and re-used later in the circuit.
 */
class QubitPool {
    constructor() {
        this.nextQubit = 0;
        this.maxQubits = 0;
        this.freedQubits = [];
    }

    alloc(circuit) {
        let newQubit;
        if (this.freedQubits.length > 0) {
            newQubit = this.freedQubits.shift()._alloc(circuit);
        } else {
            newQubit = new Qubit(circuit, this.nextQubit++);
            circuit.qubits.push(newQubit);
        }
        this.maxQubits = Math.max(this.maxQubits, newQubit.index + 1);
        return newQubit;
    }

    free(qubit) {
        this.freedQubits.push(qubit);
    }
}

module.exports = QubitPool;
